export const PROFANITY_LIST = [
  'fuck', 'shit', 'ass', 'bitch', 'dick', 'pussy', 'cock', 'cunt',
  'fag', 'nigger', 'nigga', 'retard', 'whore', 'slut'
];

/**
 * Checks if text contains profanity. Returns the offending word or null.
 */
export function containsProfanity(text) {
  if (!text) return null;
  const lower = text.toLowerCase();
  for (const word of PROFANITY_LIST) {
    if (lower.includes(word)) return word;
  }
  return null;
}

/**
 * Validates user-generated text content (comments, reviews).
 * Returns { valid: true } or { valid: false, error: string }.
 */
export function validateContent(text, { minLength = 0, maxLength = 500, label = 'Content' } = {}) {
  if (!text || !text.trim()) {
    return { valid: false, error: `${label} cannot be empty` };
  }

  const trimmed = text.trim();

  if (minLength && trimmed.length < minLength) {
    return { valid: false, error: `${label} must be at least ${minLength} characters` };
  }

  if (trimmed.length > maxLength) {
    return { valid: false, error: `${label} must be ${maxLength} characters or less` };
  }

  const badWord = containsProfanity(trimmed);
  if (badWord) {
    return { valid: false, error: `${label} contains inappropriate language. Please revise and try again.` };
  }

  return { valid: true };
}
